import { render, staticRenderFns } from "./CostTypes.vue?vue&type=template&id=cf6a64a0&scoped=true"
import script from "./CostTypes.vue?vue&type=script&lang=js"
export * from "./CostTypes.vue?vue&type=script&lang=js"
import style0 from "./CostTypes.vue?vue&type=style&index=0&id=cf6a64a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6a64a0",
  null
  
)

export default component.exports